import React from 'react'
import StatusContratoListPageContainer from './StatusContratoListPageContainer'

export class StatusContratoListPage extends React.Component {
  render() {
    return <StatusContratoListPageContainer {...this.props} />
  }
}
